import React, { useEffect, useMemo, useState } from "react";
import { v4 } from "uuid";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import { Toaster } from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SearchIcon from "@mui/icons-material/Search";
import exportExcel from "utils/excelGenerate";
import {
  getDealerChurn,
  getDealerChurnCount,
  getDealerChurnSalesData,
  getDealerChurnTimeline,
  getUsersList,
  submitChurnRemark,
} from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import styles from "./dealerChurn.module.css";
import moment from "moment";
import Chart from "react-apexcharts";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PrintIcon from "@mui/icons-material/Print";
import axios from "axios";

const messageStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100vh",
  width: "70%",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const ActionItem = ({ data, index }) => (
  <div className={styles.container}>
    {console.log("index", data)}
    <div
      className={styles.time}
      style={{
        color: index === 0 ? "green" : "#333",
        fontWeight: index === 0 ? 700 : "normal",
      }}
    >
      {moment
        .utc(data.onDate)
        .add(330, "minutes")
        .format("DD MMM YYYY hh:mm A")}
    </div>
    <div className={styles.remark}>{data.remark}</div>
    {data?.actionRemark ? (
      <p className={styles.action_remark}>{data?.actionRemark}</p>
    ) : null}
    {data?.reasons && data?.reasons.length > 0 && (
      <div className={styles.reasons}>
        <p>
          Reason:{" "}
          {data?.reasons.map((reason, idx) => (
            <span key={idx}>
              {reason}
              {idx < data?.reasons.length - 1 && " | "}
            </span>
          ))}
        </p>
      </div>
    )}
    {data?.suggestions && data.suggestions.length > 0 && (
      <div className={styles.suggestions}>
        <p>
          Suggested Actions:{" "}
          {data?.suggestions.map((suggestion, idx) => (
            <span key={idx}>
              {suggestion}
              {idx < data?.suggestions.length - 1 && " | "}
            </span>
          ))}
        </p>
      </div>
    )}
    {/* {data?.happinessScore ? (
      <p className={styles.action_remark}>{data?.happinessScore}</p>
    ) : null}
    {data?.feedback ? (
      <p className={styles.action_remark}>{data?.feedback}</p>
    ) : null} */}
    <div className={styles.notification}>{data?.additionalRemark}</div>
    {/* <div className={styles.notification}>{"notification"}</div> */}
  </div>
);

const Main = () => {
  const currentDate = new Date();
  const currentMonthNumber = currentDate.getMonth() + 1;

  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [churnCount, setChurnCount] = useState({});
  const [clubCategory, setClubCategory] = useState([]);
  const [dealerType, setDealerType] = useState([]);
  const [selectedClub, setSelectedClub] = useState("");
  const [selectedDealerType, setSelectedDealerType] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const [soResp, setSoResp] = useState({});
  const [month, setMonth] = useState(currentMonthNumber);
  const [year, setYear] = useState(2024);
  const [chartMonth, setChartMonth] = useState([]);
  const [chartSale, setChartSale] = useState([]);

  const [timelineData, setTimelineData] = useState();

  const [openModal, setOpenModal] = useState(false);
  const [comment, setComment] = useState("");

  const [riskType, setRiskType] = useState("");

  const [userList, setUserList] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState([]);

  const [showMentionList, setShowMentionList] = useState(false);
  const [assignedTo, setAssignedTo] = useState("");

  const renderRiskLevelCell = (params) => {
    const cellValue = params.value;
    if (cellValue === "High Risk") {
      return <div className={styles.highRiskRowClass}>{cellValue}</div>;
    } else if (cellValue === "Low Risk") {
      return <div className={styles.lowRiskRowClass}>{cellValue}</div>;
    } else if (cellValue === "Obvious Churner") {
      return <div className={styles.obviousRiskRowClass}>{cellValue}</div>;
    } else if (cellValue === "No Risk") {
      return <div className={styles.lowRiskRowClass}>{cellValue}</div>;
    } else if (cellValue === "Performing Well") {
      return <div className={styles.lowRiskRowClass}>{cellValue}</div>;
    }
    return cellValue;
  };

  const renderTooltipCell = (params) => {
    console.log("params", params);
  };

  const columns = useMemo(() => [
    {
      field: "dealerCode",
      headerName: "Dealer Code",
      flex: 2,
    },
    {
      field: "dealerName",
      headerName: "Dealer Name",
      flex: 4,
    },
    {
      field: "riskLevel",
      headerName: "Risk Level",
      flex: 3,
      renderCell: renderRiskLevelCell,
    },
    {
      field: "assigned",
      headerName: "Assigned To",
      flex: 2,
    },
    {
      field: "healthRemark",
      headerName: "Remarks",
      flex: 3,
      renderCell: renderRiskLevelCell,
    },
    {
      field: "status",
      headerName: "Action Plan Status",
      flex: 5,
    },
  ]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(async () => {
    await getUsersList()
      .then((response) => {
        setUserList(response?.data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  console.log("reposne", userList);

  useEffect(async () => {
    await getDealerChurnCount({ month, year })
      .then((d) => {
        const transformedObjectML = d?.churnCount.reduce((acc, item) => {
          const { risk, current, percentageChange } = item;
          const riskKey = risk.toLowerCase().replace(/\s+/g, ""); // Convert to camelCase
          acc[riskKey] = current;
          acc[`changeIn${riskKey.charAt(0).toUpperCase()}${riskKey.slice(1)}`] =
            parseFloat(percentageChange);
          return acc;
        }, {});

        const finalObjectML = {
          lowRisk: transformedObjectML.lowrisk || 0,
          highRisk: transformedObjectML.highrisk || 0,
          obviousChurner: transformedObjectML.obviouschurner || 0,
          changeInLowRisk: transformedObjectML.changeInLowrisk || 0,
          changeInHighRisk: transformedObjectML.changeInHighrisk || 0,
          changeInObviousChurner:
            transformedObjectML.changeInObviouschurner || 0,
        };
        setChurnCount(finalObjectML);

        const transformedObject = d?.soResponse.reduce((acc, item) => {
          const { risk, current, percentageChange } = item;
          const riskKey = risk.toLowerCase().replace(/\s+/g, "");
          acc[riskKey] = current;
          acc[`changeIn${riskKey.charAt(0).toUpperCase()}${riskKey.slice(1)}`] =
            parseFloat(percentageChange);
          return acc;
        }, {});

        const finalObject = {
          lowRisk: transformedObject.lowrisk || 0,
          highRisk: transformedObject.highrisk || 0,
          obviousChurner: transformedObject.obviouschurner || 0,
          changeInLowRisk: transformedObject.changeInLowrisk || 0,
          changeInHighRisk: transformedObject.changeInHighrisk || 0,
          changeInObviousChurner: transformedObject.changeInObviouschurner || 0,
        };
        setSoResp(finalObject);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [month, year]);

  let newDate = new Date(new Date().getFullYear(), month - 1, 1);
  for (let i = 3; i >= 1; i--) {
    newDate.setDate(1);
    newDate.setMonth(newDate.getMonth() - 1);
    const lastMonthShortName = newDate.toLocaleString("default", {
      month: "short",
    });
    const year = newDate.getFullYear().toString().substr(-2);
    const headerName = `${lastMonthShortName}' ${year}`;
    const field = `month${i}`;
    columns.splice(2, 0, {
      field,
      headerName,
      flex: 2,
      renderCell: renderTooltipCell,
    });
  }

  useEffect(async () => {
    await getDealerChurn({ month, year })
      .then((d) => {
        const uniqueData = d?.data.reduce(
          (result, item) => {
            if (item.clubCategory && item.clubCategory !== "") {
              result.clubCategories.add(item.clubCategory);
            }
            if (item.dealerType1 && item.dealerType1 !== "") {
              result.dealerTypes.add(item.dealerType1);
            }
            result.test.push({
              id: v4(),
              dealerCode: item?.dealerCode,
              dealerName: item?.name,
              riskLevel: item?.MLResponse,
              remark: item?.remarks.length > 0 ? item.remarks[0] : "-",
              month1: item?.MLSalesData[2]?.saleValue,
              month2: item?.MLSalesData[1]?.saleValue,
              month3: item?.MLSalesData[0]?.saleValue,
              assigned: item?.SAP_ID,
              clubCategory: item?.clubCategory,
              dealerType1: item?.dealerType1,
              healthRemark: item?.healthRemark,
              status: item?.status,
            });
            return result;
          },
          {
            clubCategories: new Set(),
            dealerTypes: new Set(),
            test: [],
          }
        );

        setClubCategory(Array.from(uniqueData.clubCategories));
        setDealerType(Array.from(uniqueData.dealerTypes));
        setData(uniqueData.test);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toastMessage("error fetching data", "error");
      });
  }, [month, year]);

  useEffect(() => {
    const res = filteredData
      .filter(
        (data) =>
          data?.dealerCode?.includes(search) ||
          data?.dealerName?.toUpperCase().includes(search.toUpperCase()) ||
          data?.assigned?.toUpperCase().includes(search.toUpperCase())
      )
      .map((item) => ({
        id: item?.id,
        dealerCode: item?.dealerCode,
        dealerName: item?.dealerName,
        riskLevel: item?.riskLevel,
        remark: item?.remark?.length > 0 ? item.remark[0] : "-",
        month1: item?.month1,
        month2: item?.month2,
        month3: item?.month3,
        assigned: item?.assigned,
        clubCategory: item?.clubCategory,
        dealerType1: item?.dealerType1,
        healthRemark: item?.healthRemark,
        status: item?.status,
      }));
    setSearchData(res);
  }, [search]);

  const generateExcel = async (e) => {
    let fileName = "Churn-Report";
    e.preventDefault();
    exportExcel(
      filteredData.map((x) => {
        let firstMonth = moment
          .utc({ month: month - 1 })
          .subtract(2, "month")
          .format("MMMM");
        let secondMonth = moment
          .utc({ month: month - 1 })
          .subtract(1, "month")
          .format("MMMM");
        let thirdMonth = moment.utc({ month: month - 1 }).format("MMMM");

        return {
          "Dealer Code": x?.dealerCode,
          "Dealer Name": x?.dealerName,
          RiskLevel: x?.riskLevel,
          [firstMonth]: x?.month1,
          [secondMonth]: x?.month2,
          [thirdMonth]: x?.month3,
          Remark: x?.healthRemark ? x?.healthRemark : "-",
          Assigned: x?.assigned,
          Status: x?.status,
        };
      }),
      fileName
    );
  };

  let conflictData = [
    {
      label: "Obvious Churner",
      id: "obviousChurner",
      change: "changeInObviousChurner",
    },
    {
      label: "High Risk",
      id: "highRisk",
      change: "changeInHighRisk",
    },
    {
      label: "Low Risk",
      id: "lowRisk",
      change: "changeInLowRisk",
    },
  ];

  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const years = [
    { value: 2022, label: 2022 },
    { value: 2023, label: 2023 },
    { value: 2024, label: 2024 },
  ];

  const clubNames = [
    { value: "GP", label: "Gold Plus" },
    { value: "BC", label: "Blue Club" },
    { value: "PL", label: "Platinum Club" },
    { value: "ST", label: "Starter Club" },
    { value: "AH", label: "Acer Club" },
    { value: "NS", label: "NON SAS" },
    { value: "DC", label: "Diamond Club" },
    { value: "CA", label: "Chairman Advisory" },
    { value: "CC", label: "Chairman Club" },
  ];

  useEffect(() => {
    let updatedData = data;
    if (selectedClub) {
      updatedData = updatedData.filter(
        (item) => item.clubCategory === selectedClub
      );
    }
    if (
      (selectedClub === "All" || selectedClub === "") &&
      selectedDealerType === ""
    ) {
      updatedData = data;
    }

    if (selectedDealerType) {
      updatedData = updatedData.filter(
        (item) => item.dealerType1 === selectedDealerType
      );
    }

    setFilteredData(updatedData);
  }, [selectedClub, selectedDealerType, data]);

  const handleConflict = (type) => {
    setRiskType(type);
    let riskLevel;

    switch (type) {
      case "obviousChurner":
        riskLevel = "Obvious Churner";
        break;
      case "highRisk":
        riskLevel = "High Risk";
        break;
      case "lowRisk":
        riskLevel = "Low Risk";
        break;
      default:
        console.log("Invalid type");
        return;
    }

    const filteredData = data.filter(
      (item) =>
        item.riskLevel === riskLevel &&
        item.healthRemark !== undefined &&
        item.healthRemark !== "" &&
        item.healthRemark !== item.riskLevel
    );

    setFilteredData(filteredData);
  };

  const handleReset = () => {
    setFilteredData(data);
    setRiskType("");
  };

  const handleDealer = async (data) => {
    setAssignedTo(data?.assigned);
    await getDealerChurnTimeline(data?.dealerCode)
      .then((res) => {
        console.log("res", res);
        setTimelineData(res.data);
        setOpenModal(true);
      })
      .catch((err) => {
        console.log("err", err);
      });

    await getDealerChurnSalesData(data?.dealerCode)
      .then((res) => {
        setChartMonth(res?.data?.map((item) => item.month).reverse());
        setChartSale(
          res?.data?.map((item) => item.SaleVal.toFixed()).reverse()
        );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const addComment = async (data) => {
    console.log("adat", timelineData);
    let remark = comment;
    await submitChurnRemark({ remark, dealerCode: data })
      .then((res) => {
        console.log("res", res);
        setTimelineData(res.data);
        setComment("");
        toastMessage(res.data.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage("error adding comment", "error");
      });
  };

  let chartDataValue = {
    options: {
      labels: chartMonth,
      title: {
        text: "Sales Performance",
        align: "center",
        style: {
          color: "lightgrey",
          marginTop: "20px",
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        area: {
          fillTo: "origin",
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      tooltip: { followCursor: true },
      yaxis: {
        labels: {},
      },
      markers: {
        size: 5,
        // colors: ["#000524"],
        strokeColor: "#00BAEC",
        // strokeWidth: 3,
      },
    },

    series: [
      {
        name: "Sales Data",
        data: chartSale,
      },
    ],
  };

  const handleInputChange = (event) => {
    const text = event.target.value;
    const words = text.split(/\s+/);
    const lastWord = words[words.length - 1];
    const isAtMention = lastWord.startsWith("@") && lastWord.length > 1;

    setShowMentionList(isAtMention);
    const filterText = lastWord.substring(1).toLowerCase();
    const filteredMentions = userList.filter((mention) =>
      mention.toLowerCase().includes(filterText)
    );
    console.log("filter", filteredMentions);

    setFilteredUserList(filteredMentions);
    setComment(text);
  };

  const handleMentionSelect = (selectedMention) => {
    const updatedComment = comment.replace(/@(\S*)$/, `@${selectedMention} `);
    setComment(updatedComment);
    setShowMentionList(false);
  };

  const printPage = () => {
    window.print();
  };

  const formatNumber = (number) => {
    return String(number).replace(/(\d)(?=(\d{2})+\d$)/g, "$1,");
  };

  return (
    <>
      <div>
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Dealer Churn Report
        </p>
      </div>
      <div
        style={{
          width: "98%",
          border: "1.5px solid grey",
          marginBottom: "1rem",
        }}
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Filter by Club</InputLabel>
            <Select
              labelId="zone-label"
              value={selectedClub}
              name="zone"
              onChange={(event) => setSelectedClub(event.target.value)}
            >
              <MenuItem value="All">
                <p>All</p>
              </MenuItem>
              {/* {clubCategory?.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))} */}
              {clubNames.map(
                (club) =>
                  clubCategory.includes(club.value) && (
                    <MenuItem key={club.value} value={club.value}>
                      {club.label}
                    </MenuItem>
                  )
              )}
            </Select>
          </FormControl>
          {/* <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Filter by Area</InputLabel>
            <Select
              labelId="zone-label"
              value={selectedZone}
              name="zone"
              onChange={handleChange}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {data?.map((item) => (
                <MenuItem key={item.zone} value={item.zone}>
                  {item.zone}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          {/* <FormControl sx={{ m: 1, minWidth: 190 }} size="small">
            <InputLabel>Filter by DealerType</InputLabel>
            <Select
              // labelId="zone-label"
              value={selectedDealerType}
              name="zone"
              onChange={(event) => setSelectedDealerType(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {dealerType?.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          {/* <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Filter by Risk</InputLabel>
            <Select
              labelId="zone-label"
              value={selectedClub}
              name="zone"
              onChange={(event) => setSelectedClub(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {clubCategory?.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Select Month</InputLabel>
            <Select
              labelId="zone-label"
              value={month}
              name="zone"
              onChange={(event) => setMonth(event.target.value)}
            >
              {months?.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Select Year</InputLabel>
            <Select
              labelId="zone-label"
              value={year}
              name="zone"
              onChange={(event) => setYear(event.target.value)}
            >
              {years?.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div>
          <FormControl sx={{ m: 1, minWidth: 400, mr: 4 }} size="small">
            <TextField
              onChange={handleChange}
              value={search}
              name="search"
              variant="outlined"
              label="Search Dealer Name or Code or Assigned"
              inputProps={{
                style: {
                  height: "12px",
                  // paddingTop: "1px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </div>
      </div>

      <div
        style={{
          margin: "1.5rem 0 2rem 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center ",
        }}
      >
        <div
          style={{
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {conflictData && conflictData.length > 0
            ? conflictData.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    width: "30%",
                    boxShadow: `rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px`,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    lineHeight: "2rem",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      color: "#526D82",
                      textDecoration: "underline",
                      fontWeight: "800",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {item.label}
                  </p>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ width: "40%" }}>
                      <p>Analytics</p>
                      <div style={{ display: "flex" }}>
                        <p
                          style={{
                            color:
                              item?.id === "obviousChurner"
                                ? "red"
                                : item?.id === "highRisk"
                                ? "orange"
                                : "green",
                            fontWeight: "600",
                          }}
                        >
                          {churnCount[item?.id]}
                        </p>
                        <Button
                          startIcon={
                            churnCount[item?.change] > 0 ? (
                              <TrendingUpIcon />
                            ) : (
                              <TrendingDownIcon />
                            )
                          }
                          style={{
                            color:
                              churnCount[item?.change] > 0 ? "red" : "green",
                            fontWeight: "600",
                          }}
                        >
                          {churnCount[item?.change]}%
                        </Button>
                      </div>
                    </div>
                    <div style={{ width: "40%" }}>
                      <p>Ground Staff</p>
                      <div style={{ display: "flex" }}>
                        <p
                          style={{
                            color:
                              item?.id === "obviousChurner"
                                ? "red"
                                : item?.id === "highRisk"
                                ? "orange"
                                : "green",
                            fontWeight: "600",
                          }}
                        >
                          {soResp[item?.id]}
                        </p>
                        <Button
                          startIcon={
                            soResp[item?.change] > 0 ? (
                              <TrendingUpIcon />
                            ) : (
                              <TrendingDownIcon />
                            )
                          }
                          style={{
                            color: soResp[item?.change] > 0 ? "red" : "green",
                            fontWeight: "600",
                          }}
                        >
                          {soResp[item?.change]}%
                        </Button>
                      </div>
                    </div>
                  </div>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "14px",
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    // onClick={(e) => handleConflict(item?.id)}
                    onClick={(e) => {
                      if (riskType === item?.id && item?.id !== "Reset") {
                        // Handle the "Reset" case
                        handleReset(item?.id);
                      } else {
                        // Handle the "View Conflict" case
                        handleConflict(item?.id);
                      }
                    }}
                  >
                    {riskType === item?.id ? "Reset" : "View Conflict"}
                  </p>
                </div>
              ))
            : null}
        </div>

        <Button
          variant="contained"
          startIcon={<CloudDownloadIcon />}
          onClick={generateExcel}
          sx={{ mr: 4, mt: 13 }}
        >
          Download Report
        </Button>
      </div>

      <div style={{ width: "98%", marginTop: "1rem", marginBottom: "2rem" }}>
        {loading ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={search ? searchData : filteredData}
            columns={columns}
            autoHeight={true}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            className="TableCell"
            rowsPerPageOptions={[10, 25, 50, 100]}
            // checkboxSelection
            onRowClick={(row) => handleDealer(row.row)}
            sx={{ fontSize: "0.75rem" }}
            // getRowClassName={(params) => {
            //   console.log("object", params.row.riskLevel);
            //   if (params.row.riskLevel === "High Risk") {
            //     return styles.highRiskRowClass;
            //   }
            //   return "";
            // }}
          />
        )}
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={messageStyle} className="modal-content">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
              marginTop: "5px",
            }}
          >
            <div>
              <h3 style={{ color: "#1976d2", fontWeight: "600" }}>
                {timelineData?.name}
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "32%",
              }}
            >
              <div
                onClick={printPage}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#7C96AB",
                }}
              >
                <PictureAsPdfIcon />
                <p style={{ marginLeft: "10px" }}>Download PDF</p>
              </div>
              <div
                onClick={printPage}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#7C96AB",
                }}
              >
                <PrintIcon />
                <p style={{ marginLeft: "10px" }}>Print</p>
              </div>
              <CloseIcon
                style={{
                  fontSize: "36px",
                  color: "darkgray",
                  cursor: "pointer",
                }}
                onClick={() => setOpenModal(false)}
              />
            </div>
          </div>
          <hr
            style={{
              border: "none",
              borderBottom: "1px dotted #ccc",
              margin: "0px 0",
            }}
          />
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: "70%",
                borderRight: "1px dotted #ccc",
                paddingRight: "1rem ",
              }}
            >
              <Chart
                type="area"
                width={"100%"}
                height={"250px"}
                series={chartDataValue.series}
                options={chartDataValue.options}
              />
              <h4></h4>
            </div>
            <div
              style={{
                width: "30%",
                // padding: "0 2rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                borderRight: "1px dotted #ccc",
                padding: "10px 20px",
              }}
            >
              <div style={{ fontWeight: "bolder" }}>
                <p style={{ color: "#1976d2" }}>
                  SAS <span style={{ color: "darkgray" }}>AOD</span>
                </p>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#7C96AB",
                    marginTop: "5px",
                  }}
                >
                  {formatNumber(parseInt(timelineData?.sasOut))}
                </h4>
              </div>
              <div style={{ margin: "10px 0", fontWeight: "bolder" }}>
                <p style={{ color: "#1976d2" }}>Outstanding</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ lineHeight: "20px" }}>
                    <p style={{ color: "darkgrey", fontSize: "12px" }}>
                      60 days
                    </p>
                    <h4 style={{ fontWeight: "bold", color: "#7C96AB" }}>
                      {formatNumber(parseInt(timelineData?.out60))}
                    </h4>
                  </div>
                  <div>
                    <p style={{ color: "darkgrey", fontSize: "12px" }}>
                      90 days
                    </p>
                    <h4 style={{ fontWeight: "bold", color: "#7C96AB" }}>
                      {formatNumber(parseInt(timelineData?.outAbove90))}
                    </h4>
                  </div>
                </div>
              </div>
              <div style={{ fontWeight: "bolder" }}>
                <p style={{ color: "#1976d2" }}>Overdue</p>
                <div>
                  <h4 style={{ fontWeight: "bold", color: "#7C96AB" }}>
                    {formatNumber(parseInt(timelineData?.overdue))}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <hr
            style={{
              border: "none",
              borderBottom: "1px dotted #ccc",
              margin: "0px 0",
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "2rem",
              fontSize: "14px",
            }}
          >
            <div>
              <p
                style={{
                  fontWeight: "bold",
                  color: "grey",
                }}
              >
                Timeline
              </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "60%",
              }}
            >
              <div>
                <p
                  style={{
                    fontWeight: "bold",
                    color: "darkgrey",
                  }}
                >
                  Action Plan{" "}
                  <span
                    style={{
                      marginLeft: "1rem",
                      fontWeight: "bolder",
                      color: "grey",
                    }}
                  >
                    {"Executed by "}
                    {assignedTo}
                  </span>
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontWeight: "bold",
                    color: "darkgrey",
                  }}
                >
                  Impact{" "}
                  <span
                    style={{
                      marginLeft: "1rem",
                      fontWeight: "bolder",
                      color: "grey",
                    }}
                  >
                    Available in next cycle
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              height: "20px",
              borderLeft: "2px dotted #888",
              marginLeft: "6px",
            }}
          ></div>

          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "5px",
                padding: "10px",
                // marginTop: "1rem",
                position: "relative",
              }}
            >
              <input
                type="text"
                style={{
                  flex: "1",
                  border: "none",
                  outline: "none",
                  padding: "8px",
                }}
                value={comment}
                placeholder="Write something..."
                onChange={handleInputChange}
              />
              {showMentionList && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 1,
                    top: "100%",
                    left: 0,
                    // border: "1px solid red",
                    width: "100%",
                    maxHeight: "150px",
                    overflowY: "auto",
                    margin: "5px 0",
                    border: "1px solid darkgrey",
                    borderRadius: "5px",
                  }}
                >
                  <ul
                    style={{
                      backgroundColor: "#ECECEC",
                      padding: "0 10px",
                      margin: 0,
                      listStyle: "none",
                    }}
                  >
                    {filteredUserList && filteredUserList.length > 0
                      ? filteredUserList.map((mention) => (
                          <li
                            key={mention}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              listStyle: "none",
                              fontWeight: "bold",
                              color: "darkgray",
                            }}
                            onClick={() => handleMentionSelect(mention)}
                          >
                            {mention}
                          </li>
                        ))
                      : userList.map((mention) => (
                          <li
                            key={mention}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              listStyle: "none",
                              fontWeight: "bold",
                              color: "darkgray",
                            }}
                            onClick={() => handleMentionSelect(mention)}
                          >
                            {mention}
                          </li>
                        ))}
                  </ul>
                </div>
              )}
              <button
                style={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: "3px",
                  cursor: "pointer",
                }}
                onClick={() => addComment(timelineData.dealerCode)}
              >
                Post
              </button>
            </div>
            <div
              style={{
                height: "40px",
                borderLeft: "2px dotted #888",
                marginLeft: "6px",
              }}
            >
              <p
                style={{
                  marginLeft: "2rem",
                  fontSize: "14px",
                  fontFamily: "Areil",
                  margin: "0 20px",
                  paddingTop: "10px",
                }}
              >
                Use{" "}
                <span style={{ color: "#1976d2", fontWeight: "bold" }}>
                  @ symbol
                </span>{" "}
                on your keyboard to assign/escalate this to someone else or
                leave a remark
              </p>
            </div>
          </div>
          <div className={styles.timeline}>
            {timelineData?.remarks &&
              timelineData?.remarks.map((item, index) => (
                <ActionItem
                  key={index}
                  data={item}
                  // time={item.time}
                  // action={item.action}
                  // remark={item.remark}
                  // notification={item.notification}
                  // isSelected={item.isSelected}
                  index={index}
                />
              ))}
          </div>

          {/* {timelineData ? (
            <TableRow>
              <TableCell>{timelineData.dealerCode}</TableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          )}
          {console.log("modal", timelineData)}
          <Box sx={{ m: 3, display: "flex", justifyContent: "center" }}>
            <Button variant="contained" onClick={() => setOpenModal(false)}>
              Close
            </Button>
          </Box> */}
        </Box>
      </Modal>
    </>
  );
};

const DealerChurn = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default DealerChurn;
